
import { Component, Vue } from 'vue-property-decorator'
import { getWaterVoucherPurchasePage } from '@/api/record'
import UserNameRemark from '@/components/UserNameRemark/index.vue'

@Component({ name: 'WaterVoucherPurchaseLog', components: { UserNameRemark } })
export default class extends Vue {
  private loading = false
  private list: any[] = []
  private total = 0
  private query = {
    pageNum: 1,
    pageSize: 10,
    userPhone: '',
    orderNumber: '',
    packageType: null as number | null,
    status: null as number | null
  }

  mounted() { this.loadList() }

  private async loadList() {
    this.loading = true
    try {
      const params: any = { pageNum: this.query.pageNum, pageSize: this.query.pageSize }
      if (this.query.userPhone) params.userPhone = this.query.userPhone.trim()
      if (this.query.orderNumber) params.orderNumber = this.query.orderNumber.trim()
      if (this.query.status != null) params.status = this.query.status
      if (this.query.packageType != null) params.packageType = this.query.packageType
      const res: any = await getWaterVoucherPurchasePage(params)
      if (String(res.data.code) === '1' && res.data.data) {
        this.list = res.data.data.records || []
        this.total = res.data.data.total || 0
      } else {
        this.list = []
        this.total = 0
      }
    } finally {
      this.loading = false
    }
  }

  private giftSummary(row: any): string {
    const gifts = (row && row.gifts) || []
    if (!Array.isArray(gifts) || !gifts.length) return '—'
    return gifts
      .map((g: any) => {
        const name = (g && (g.giftDishName || g.name)) || '赠品'
        const copies = (g && (g.giftCopies || g.copies)) || 1
        return `${name}×${copies}`
      })
      .join('、')
  }

  private tableIndex(index: number) {
    return (this.query.pageNum - 1) * this.query.pageSize + index + 1
  }

  private handleSearch() { this.query.pageNum = 1; this.loadList() }
  private handleReset() {
    this.query = {
      pageNum: 1,
      pageSize: 10,
      userPhone: '',
      orderNumber: '',
      packageType: null,
      status: null
    }
    this.loadList()
  }
}
